import React from 'react';
import {Container ,Navbar , NavDropdown, Nav} from 'react-bootstrap';
import logo2 from'../component/HSL2.png';
import logo1 from '../component/HSL1.png';
import { Divider  } from 'antd';



// import NavDropdown from 'react-bootstrap/NavDropdown';

export default function NavbarMenu() {
  return (
    <div>
      <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand href="https://www.hushstory.com/"><img src={logo1} width="50" height ="50" alt="logo" /> <img src={logo2} width="150"  alt="logo" /></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {/* <Space wrap>
           
          </Space> */}
           {/* <a style={{textDecoration: 'none'}} href="/" > <p style={{color: 'black'}}> Home</p> </a> 
            <Divider  type="vertical"></Divider> */}
            <Nav.Link href="https://www.hushstory.com/">Home</Nav.Link>
            <Divider  type="vertical"></Divider>
            <Nav.Link href="https://www.hushstory.com/poem">Poem</Nav.Link>
            <Divider  type="vertical"></Divider>
            <Nav.Link href="https://www.hushstory.com/ebooks">E-Books</Nav.Link>
            <Divider  type="vertical"></Divider>
            <NavDropdown title="Tools" id="basic-nav-dropdown" style={{color: 'black'}}>
              <NavDropdown.Item href="/emi-calculator">Emi Calculator</NavDropdown.Item>
              <NavDropdown.Item href="/search-pincode">Search Pincode</NavDropdown.Item>
              {/* <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item> */}
            </NavDropdown>
         
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </div>
  );
}





